const plans = [
  {
    name: "SMS",
    desc: "90byte (한글 45자)",
    price: "20",
    unit: "원/건",
    popular: false,
    color: "violet",
    features: ["즉시 발송", "발송 결과 확인", "예약 발송"],
    buttonStyle: "outline",
  },
  {
    name: "LMS",
    desc: "2,000byte (한글 1,000자)",
    price: "50",
    unit: "원/건",
    popular: true,
    color: "pink",
    features: ["장문 메시지", "발송 결과 확인", "예약 발송", "대량 발송"],
    buttonStyle: "filled",
  },
  {
    name: "MMS",
    desc: "이미지 포함 발송",
    price: "100",
    unit: "원/건",
    popular: false,
    color: "violet",
    features: ["이미지 첨부", "발송 결과 확인", "예약 발송", "대량 발송"],
    buttonStyle: "outline",
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="bg-[#0a0a18] py-24 px-6 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-violet-900/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase mb-3 block">
            PRICING
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">심플한 요금제</h2>
          <p className="text-gray-400 text-base">숨겨진 비용 없이, 사용한 만큼만 결제하세요</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 ${
                plan.popular
                  ? "bg-gradient-to-b from-violet-900/60 to-pink-900/40 border-2 border-violet-500/50 scale-105"
                  : "bg-white/5 border border-white/10 hover:border-white/20"
              }`}
            >
              {/* Popular badge */}
              {plan.popular && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="bg-gradient-to-r from-violet-500 to-pink-500 text-white text-xs font-semibold px-4 py-1 rounded-full whitespace-nowrap">
                    인기
                  </span>
                </div>
              )}

              {/* Plan name */}
              <h3
                className={`text-2xl font-bold mb-1 ${
                  plan.popular ? "text-pink-400" : plan.name === "MMS" ? "text-violet-300" : "text-violet-400"
                }`}
              >
                {plan.name}
              </h3>
              <p className="text-gray-400 text-sm mb-6">{plan.desc}</p>

              {/* Price */}
              <div className="flex items-end gap-1 mb-8">
                <span className="text-5xl font-black text-white">{plan.price}</span>
                <span className="text-gray-400 text-base mb-1">{plan.unit}</span>
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-sm text-gray-300">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`ri-check-line text-sm ${
                          plan.popular ? "text-pink-400" : "text-violet-400"
                        }`}
                      ></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>

              {/* Button */}
              <button
                className={`w-full py-3 rounded-lg font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                  plan.popular
                    ? "bg-gradient-to-r from-violet-600 to-pink-600 hover:from-violet-500 hover:to-pink-500 text-white"
                    : "border border-white/20 hover:border-violet-500/50 text-white hover:bg-white/5"
                }`}
              >
                시작하기
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}